import {
  CashoutAccepted,
  CashoutRejected,
  CashoutUnavailable,
  LiveCashoutOffer,
  PendingTicket,
} from '../../data-types/betting/bettingInterfaces';
import { Ticket } from '../../data-types/sports/sportsInterfaces';
import { SystemBetPlacementResult, TicketPresentationDetails } from '../../data-types/ticket/ticketInterfaces';
import { ResetState } from './stateTypes';

export type TicketActionType =
  | ResetState
  | EnqueueTicket
  | DequeueTicket
  | SetPendingTicketStatuses
  | SetCashoutOfferUpdate
  | FlushCashoutOfferUpdates
  | SetCashoutOfferAccepted
  | SetCashoutOfferRejected
  | SetCashoutOfferUnavailable
  | EnqueueBoostedSystemBetTicket
  | DequeueAllBoostedSystemBetTicket
  | SetSuccessSystemBetPlaced
  | SetFailureSystemBetPlaced
  | RemoveSuccessSystemBetPlaced
  | RemoveFailureSystemBetPlaced
  | RemoveSpecificSuccessSystemBetPlaced
  | DequeueAllTickets;

export const ENQUEUE_TICKET = 'ENQUEUE_TICKET';
export const DEQUEUE_TICKET = 'DEQUEUE_TICKET';
export const SET_PENDING_TICKET_STATUSES = 'SET_PENDING_TICKET_STATUSES';
export const SET_CASHOUT_OFFER_UPDATE = 'SET_CASHOUT_OFFER_UPDATE';
export const FLUSH_CASHOUT_OFFER_UPDATES = 'FLUSH_CASHOUT_OFFER_UPDATES';
export const SET_CASHOUT_OFFER_ACCEPTED = 'SET_CASHOUT_OFFER_ACCEPTED';
export const SET_CASHOUT_OFFER_REJECTED = 'SET_CASHOUT_OFFER_REJECTED';
export const SET_CASHOUT_OFFER_UNAVAILABLE = 'SET_CASHOUT_OFFER_UNAVAILABLE';
export const ENQUEUE_BOOSTED_SYSTEM_BET_TICKET = 'ENQUEUE_BOOSTED_SYSTEM_BET_TICKET';
export const DEQUEUE_ALL_BOOSTED_SYSTEM_BET_TICKET = 'DEQUEUE_ALL_BOOSTED_SYSTEM_BET_TICKET';
export const SET_SUCCESS_SYSTEM_BET_PLACED = 'SET_SUCCESS_SYSTEM_BET_PLACED';
export const SET_FAILED_SYSTEM_BET_PLACED = 'SET_FAILED_SYSTEM_BET_PLACED';
export const REMOVE_SUCCESS_SYSTEM_BET_PLACED = 'REMOVE_SUCCESS_SYSTEM_BET_PLACED';
export const REMOVE_FAILED_SYSTEM_BET_PLACED = 'REMOVE_FAILED_SYSTEM_BET_PLACED';
export const REMOVE_SPECIFIC_SUCCESS_SYSTEM_BET_PLACE = 'REMOVE_SPECIFIC_SUCCESS_SYSTEM_BET_PLACE';
export const DEQUEUE_ALL_TICKETS = 'DEQUEUE_ALL_TICKETS';

export interface TicketState {
  pendingTickets: PendingTicket;
  queuedTickets: TicketPresentationDetails[];
  liveCashoutOffers: {
    [key: number]: {
      offerValue: number | null;
      accepted: boolean;
      rejected: boolean;
      unavailable: boolean;
      boostedCashoutOffer: number | null;
    };
  };
  queuedBoostedSystemBetTickets: Ticket[];
  successPlacedSystemBets: SystemBetPlacementResult[];
  failedPlacedSystemBets: SystemBetPlacementResult[];
}

interface SetPendingTicketStatuses {
  type: typeof SET_PENDING_TICKET_STATUSES;
  meta: PendingTicket;
}

interface EnqueueTicket {
  type: typeof ENQUEUE_TICKET;
  meta: TicketPresentationDetails;
}

interface DequeueTicket {
  type: typeof DEQUEUE_TICKET;
}

interface SetCashoutOfferUpdate {
  type: typeof SET_CASHOUT_OFFER_UPDATE;
  meta: LiveCashoutOffer;
}

interface FlushCashoutOfferUpdates {
  type: typeof FLUSH_CASHOUT_OFFER_UPDATES;
}

interface SetCashoutOfferAccepted {
  type: typeof SET_CASHOUT_OFFER_ACCEPTED;
  meta: CashoutAccepted;
}

interface SetCashoutOfferRejected {
  type: typeof SET_CASHOUT_OFFER_REJECTED;
  meta: CashoutRejected;
}

interface SetCashoutOfferUnavailable {
  type: typeof SET_CASHOUT_OFFER_UNAVAILABLE;
  meta: CashoutUnavailable;
}

interface EnqueueBoostedSystemBetTicket {
  type: typeof ENQUEUE_BOOSTED_SYSTEM_BET_TICKET;
  meta: Ticket;
}

interface DequeueAllBoostedSystemBetTicket {
  type: typeof DEQUEUE_ALL_BOOSTED_SYSTEM_BET_TICKET;
}

interface SetSuccessSystemBetPlaced {
  type: typeof SET_SUCCESS_SYSTEM_BET_PLACED;
  meta: SystemBetPlacementResult;
}

interface SetFailureSystemBetPlaced {
  type: typeof SET_FAILED_SYSTEM_BET_PLACED;
  meta: SystemBetPlacementResult;
}

interface RemoveSuccessSystemBetPlaced {
  type: typeof REMOVE_SUCCESS_SYSTEM_BET_PLACED;
}

interface RemoveFailureSystemBetPlaced {
  type: typeof REMOVE_FAILED_SYSTEM_BET_PLACED;
}

interface RemoveSpecificSuccessSystemBetPlaced {
  type: typeof REMOVE_SPECIFIC_SUCCESS_SYSTEM_BET_PLACE;
  meta: number;
}

interface DequeueAllTickets {
  type: typeof DEQUEUE_ALL_TICKETS;
}
